@if (shouldShowWrapper) {
  <div class="app-ui-wrapper">
    <!-- Side Navigation -->
    <div class="side-nav" [class.collapsed]="isCollapsed">
      <!-- Collapse / Expand Toggle -->
      <button
        type="button"
        class="sidebar-toggle"
        (click)="toggleSidebar()"
        [disabled]="isBelowTabletBreakpoint"
        [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
        [attr.aria-expanded]="!isCollapsed"
      >
        <span class="mso">{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</span>
      </button>

      <!-- Logo Section -->
      <div class="sidebar-logo">
        @if (!isCollapsed) {
          <app-dealiodesk-logo class="brand-logo" variant="full" [height]="64" />
        }
        @else {
          <app-dealiodesk-logo class="brand-logo brand-logo-mobile" variant="icon" [height]="64" />
        }
      </div>
 
      <!-- User Info -->
      @if (!isCollapsed) {
        <div class="user-info">
          <app-user-profile-img [firstName]="currentUserFirstName" [lastName]="currentUserLastName" [size]="'48px'" [fontSize]="'20px'" [colorPalete]="'hash'" />
          <div class="user-info-content">
            <h5>{{ currentUserDisplayName }}</h5>
            <span class="user-email">{{ currentUserEmail }}</span>
            <span class="user-role">{{ currentUserRole }}</span>
          </div>
        </div>
      }

      <!-- Main Navigation Items -->
      <div class="nav-main">
        @for (item of navItems; track item.route) {
          @if (hasPermission(item.permissions)) {
            <app-button
              [elementStyle]="getNavItemStyle(item.route)"
              (onClick)="navigateTo(item.route)"
              [disabled]="false"
              [style]="'text-white'"
              [justify]="isCollapsed ? 'center' : 'flex-start'"
              [text]="isCollapsed ? '' : item.label"
              [msoIcon]="item.msoIcon"
            ></app-button>
          }
        }
      </div>

      <!-- Preflight Environment options for development and testing -->
      @if (isPreflightEnv && !isCollapsed) {
        <div class="nav-dev">
          <app-env-tag></app-env-tag>
          <app-button
            (onClick)="refreshPermissions()"
            [disabled]="isRefreshingPermissions"
            [style]="'text-white'"
            [justify]="isCollapsed ? 'center' : 'flex-start'"
            [text]="isCollapsed ? '' : (isRefreshingPermissions ? 'Refreshing...' : 'Refresh Permissions')"
          ></app-button>
          <app-button
            (onClick)="navigateToDocuments()"
            [disabled]="isRefreshingPermissions"
            [style]="'text-white'"
            [justify]="isCollapsed ? 'center' : 'flex-start'"
            [text]="isCollapsed ? '' : 'Documents'"
        ></app-button>
        <app-button
          (onClick)="navigateToDashboard()"
          [disabled]="isRefreshingPermissions"
          [style]="'text-white'"
          [justify]="isCollapsed ? 'center' : 'flex-start'"
          [text]="isCollapsed ? '' : 'Dashboard'"
        ></app-button>
        </div>
      }
 
      <!-- Bottom Navigation Items -->
      <div class="nav-bottom">
        <app-button
          (onClick)="handleLogout()"
          [disabled]="false"
          [style]="'text-white'"
          [justify]="isCollapsed ? 'center' : 'flex-start'"
          [text]="isCollapsed ? '' : 'Logout'"
          [msoIcon]="'logout'"
        ></app-button>
      </div>
     
    </div>
 
    <!-- Main Content Area -->
    <div class="main-content" [class.sidebar-collapsed]="isCollapsed">
      <!-- Breadcrumbs -->
      <app-breadcrumbs></app-breadcrumbs>
 
      <!-- Page Content -->
      <div class="content-wrapper">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
} @else {
  <div class="fullpage-wrapper">
    <router-outlet></router-outlet>
  </div>
}